export enum Result {
    Success,
    Validation,
    Error,
}

interface SuccessResponse<T> {
    result: Result.Success;
    data?: T;
}

interface ValidationResponse {
    result: Result.Validation;
    errors: Array<{field: string; error: string}>;
}

interface ErrorResponse {
    result: Result.Error;
}

export type Response<T = undefined> = SuccessResponse<T> | ValidationResponse | ErrorResponse;
